var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('van-loading',{attrs:{"size":"24px","vertical":""}},[_vm._v("正在进入物联网平台...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }